
import React from 'react';

export default () => (
  <p>
    I know several languages but I'm most proficient with Ruby.
    I can build robust Ruby code using TDD methodology.
    I am proficient in using the following tools to achieve this task:
    RSpec, Capybara, Cucumber, MiniTest, Rake, Rails, rbenv
  </p>
);



// WEBPACK FOOTER //
// ./src/components/stacks/more_info/Ruby.js